import { usePharmacy } from '@/context/PharmacyContext';

export default function BlogCTABar() {
  const { settings } = usePharmacy();

  return (
    <section className="relative w-full overflow-hidden my-12">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20organic%20flowing%20shapes%20in%20terracotta%20beige%20and%20cream%20tones%20soft%20modern%20aesthetic%20calming%20healthcare%20pharmaceutical%20editorial%20background%20wide%20banner&width=1920&height=300&seq=blog-cta-strip-v1&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
          width={1920}
          height={300}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/90 to-foreground-900/70" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-10 md:py-14">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-white mb-2">
              Ready to Start Your Recovery Journey?
            </h2>
            <p className="text-sm text-white/70 max-w-lg">
              Our compassionate team at {settings?.pharmacy_name || 'Thornhill Drug-Mart'} is here to help. Reach out today for confidential support.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={`tel:${settings?.phone_raw || '9057099985'}`}
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 dark:text-foreground-950 font-semibold px-6 py-3 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer justify-center"
            >
              <i className="ri-phone-line"></i>
              Call Now
            </a>
            <a
              href="/addiction-services"
              className="inline-flex items-center gap-2 border border-white/40 hover:border-white text-white font-semibold px-6 py-3 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer justify-center"
            >
              <i className="ri-heart-pulse-line"></i>
              Our Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}